const HaloPSAConnect = () => import('@/views/account/integrations/halopsa/halopsa-connect-view.vue');
const HaloPsaManage = () => import('@/views/account/integrations/halopsa/halopsa-manage-view');

import store from '@/stores/index';

import HaloPSAMappingRoutes from '@/routes/integrations/halopsa/mapping';
import HaloPSAImportRoutes from '@/routes/integrations/halopsa/import';

export default [
    {
        path: '/Integrations/HaloPSA/Manage',
        name: 'HaloPSAManage',
        component: HaloPsaManage,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page',
            pageTitle: 'Manage Halo PSA Integration'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/HaloPSA/Manage',
        name: 'ClientHaloPSAManage',
        component: HaloPsaManage,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page',
            pageTitle: 'Manage Halo PSA Integration'
        }
    },
    {
        path: '/Integrations/HaloPSA/Manage/Connection',
        name: 'HaloPSAConnect',
        component: HaloPSAConnect,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page',
            pageTitle: 'Manage Halo PSA Integration'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/HaloPSA/Manage/Connection',
        name: 'ClientHaloPSAConnect',
        component: HaloPSAConnect,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page',
            pageTitle: 'Manage Halo PSA Integration'
        }
    },
    ...HaloPSAMappingRoutes,
    ...HaloPSAImportRoutes
]